<!--
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
-->
<div class="content-heading">
  <h3>{{locoLabel?.fuel|uppercase}}</h3>
</div>
<div class="loco-fuel-gauze-container">
<lms-loco-fuel-svg [locoData]='locoData'></lms-loco-fuel-svg>
<p>{{locoData?.fuelLevelSource}}</p>
</div>
<table class="table table-no-border two-col-tbl">
  <tbody>
    <tr>
      <td>{{locoLabel?.lastFueled}}</td>
      <td *ngIf="returnDash([locoData?.lastFueledDate,locoData?.lastFueledLocation])">-</td>
      <td *ngIf="!returnDash([locoData?.lastFueledDate,locoData?.lastFueledLocation])">{{locoData?.lastFueledDate}} <br>{{locoData?.lastFueledLocation}}</td>
    </tr>
    <tr>
      <!--<td>{{locoLabel?.hsFuelCount}}</td>-->
      <td>
        <p>Consecutive</p>
        <p>High Speed Truck</p>
        <p>Fuel Count</p>
      </td>
      <td></td>
    </tr>
  </tbody>
</table>
<div class="seperator"></div>
<table class="table table-no-border two-col-tbl" *ngIf="tab?.mode!='edit'">
  <tbody>
    <tr>
      <td>{{locoLabel?.availableCapacity}}</td>
      <td>{{locoData?.capacity|locoBlankString}}</td>
    </tr>
    <tr>
      <td>{{locoLabel?.milesToEmpty}}</td>
      <td>{{locoData?.miles|locoBlankString}}</td>
    </tr>
    <tr>
      <td>{{locoLabel?.bulkRange}}</td>
      <td>{{locoData?.bulkRange|locoBlankString}}</td>
    </tr>
    <tr>
      <td>{{locoLabel?.mfstRange}}</td>
      <td>{{locoData?.manifestRange|locoBlankString}}</td>
    </tr>
    <tr>
      <td>{{locoLabel?.mixedRange}}</td>
      <td>{{locoData?.mixedRange|locoBlankString}}</td>
    </tr>
    <tr>
      <td>{{locoLabel?.fuelLevel}}: {{isFuelLevelSourcePresent(locoData?.fuelLevelSource)}}</td>
      <td>{{locoData?.fuelLevel|locoBlankString}}</td>
    </tr>
  </tbody>
</table>
<div *ngIf="tab?.mode==='edit'" [formGroup]="locoFuelForm">
  <table class="table table-no-border two-col-tbl">
    <tbody>
      <tr>
        <td>{{locoLabel?.availableCapacity}}</td>
        <td>
          <input type="text" spellcheck="false" class="{{errorMap.get('capacityError')?'p-inputfield p-inputfield-error':'p-inputfield'}}"
            formControlName="capacity" (keypress)="appUtilityService.isNumber($event)" maxlength="4" tabindex="2458">
        </td>
      </tr>
      <tr>
        <td>{{locoLabel?.milesToEmpty}}</td>
        <td>
          <input type="text" spellcheck="false" class="{{errorMap.get('milesError')?'p-inputfield p-inputfield-error':'p-inputfield'}}"
            formControlName="miles" (keypress)="appUtilityService.isNumber($event)" maxlength="4" tabindex="2459">
        </td>
      </tr>
      <tr>
        <td>{{locoLabel?.bulkRange}}</td>
        <td>{{locoData?.bulkRange|locoBlankString}}</td>
      </tr>
      <tr>
        <td>{{locoLabel?.mfstRange}}</td>
        <td>{{locoData?.manifestRange|locoBlankString}}</td>
      </tr>
      <tr>
        <td>{{locoLabel?.mixedRange}}</td>
        <td>{{locoData?.mixedRange|locoBlankString}}</td>
      </tr>
      <tr>
        <td>{{locoLabel?.fuelLevel}}: {{isFuelLevelSourcePresent(locoData?.fuelLevelSource)}} </td>
        <td>
          <input type="text" spellcheck="false" class="{{errorMap.get('fuelLevelError')?'p-inputfield p-inputfield-error':'p-inputfield'}}"
            formControlName="fuelLevel" (keypress)="appUtilityService.isNumber($event)" maxlength="4" tabindex="2460">
        </td>
      </tr>
    </tbody>
  </table>
</div>